import { resource } from '../http'

export const Level = resource("/level");

export default Level;
